var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaCarregadeira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.78,
    height: 26.716,
    viewBox: "0 0 45.78 26.716",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_910",
    "data-name": "Caminho 910",
    d: "M338.775,504.9l-1.153-7.487-12.334-1.533-1.7-8.02h-8.521l-1.679,7.547h-1.239l-1.562,2.153-4.327-4.386-.046.016v-.016h-4.146c0-.482,0-.964,0-1.446a1.367,1.367,0,0,0-.472-1.172,7.849,7.849,0,0,1-1.005-1.026,1.407,1.407,0,0,0-1.411-.6,4.479,4.479,0,0,1-.642,0c-1.013,2.729-2.012,5.424-3.012,8.118-.258.7-.534,1.388-.771,2.093-.1.307-.234.5-.587.423-.42-.086-.627.108-.736.506s-.277.773-.442,1.224c.2.014.356.033.509.033,2.018,0,4.038.013,6.056-.011a1.187,1.187,0,0,0,.724-.3,6.325,6.325,0,0,0,1.682-1.787,6.549,6.549,0,0,0,.1-2.4c0-.135,0-.27,0-.406h2.377l1.84,6.218c-.173-.014-.34-.052-.517-.052a5.988,5.988,0,1,0,5.866,7.194h11.656a5.988,5.988,0,0,0,11.731,0H336.8Z",
    transform: "translate(-292.995 -487.858)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaCarregadeira);
export default __webpack_public_path__ + "static/media/pa-carregadeira.ce546e28872e84332e28d38ad966c82d.svg";
export { ForwardRef as ReactComponent };